import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ToastItemComponent } from './toast-item/toast-item.component';
import { ToastComponent } from './toast.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
  declarations: [ToastItemComponent, ToastComponent],
  exports: [ToastComponent]
})
export class ToastModule {}
